import script from "./SurveyIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyIntro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__